module.exports = __webpack_public_path__ + "img/00049.b499e73a.webp";